import { render, staticRenderFns } from "./selectSubsidiary4.vue?vue&type=template&id=01bd7480&scoped=true"
import script from "./selectSubsidiary4.vue?vue&type=script&lang=js"
export * from "./selectSubsidiary4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd7480",
  null
  
)

export default component.exports